import type { ComponentType } from 'react';

import { Switch } from '@genially/design-system';

import { Label, StyledIcon, Wrapper } from './ConfigToggle.styled';

interface ConfigToggleProps {
  Icon: ComponentType;
  text: string;
  checked: boolean;
  onChange: () => void;
}

export const ConfigToggle = ({ Icon, text, checked, onChange }: ConfigToggleProps) => {
  const handleChange = () => onChange();

  return (
    <Wrapper>
      <StyledIcon as={Icon} />
      <Label>{text}</Label>
      <Switch checked={checked} onChange={handleChange} />
    </Wrapper>
  );
};
